import { getSintegradaServerApi } from "@/services/api";
import { OccupationPaginated } from "@/@types/sintegrada/OccupationPaginated";
import { InternalDepartmentParams } from "@/@types/sintegrada/InternalDepartmentParams";
import { ResumeGrouped } from "@/services/esus/attendanceService";

export type InternalDepartmentResume = {
	department: ResumeGrouped<string, object>[];
};

export async function getDepartmentObservations({
	uf,
	ibgeCode,
	...params
}: InternalDepartmentParams) {
	const url = `/2/Occupation/department-observations`;

	const { data } = await getSintegradaServerApi().get<OccupationPaginated>(url, {
		ibgeCode,
		...params,
	});

	return data || ({} as OccupationPaginated);
}
